/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import Content from "../../../Components/Dashboard/Content/Content";

import { Get_Strategy_Description } from "../../../ReduxStore/Slice/Users/StrategySlice";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../../Components/ExtraComponents/Modal";

const StrategyDesc = () => {
  const dispatch = useDispatch();

  const [StrategyData, setStrategyData] = useState({ loading: true, data: [] });

  const [showModal, setshowModal] = useState(false);
  const [ModalData, setModalData] = useState("");

  const user_Id = JSON.parse(localStorage.getItem("user_details")).user_id;
  const AdminToken = JSON.parse(localStorage.getItem("user_details")).token;

  const gotodashboard = JSON.parse(localStorage.getItem("gotodashboard"));
  const GoToDahboard_id = JSON.parse(localStorage.getItem("user_details_goTo"));

  const getsignals11 = async (e) => {
    await dispatch(
      Get_Strategy_Description({
        _id: gotodashboard ? GoToDahboard_id.user_id : user_Id,
        token: AdminToken,
      })
    )
      .unwrap()
      .then((response) => {
        if (response.status) {
          setStrategyData({
            loading: false,
            data: response.data,
          });
        } else {
          setStrategyData({
            loading: false,
            data: response.data,
          });
        }
      });
  };

  useEffect(() => {
    getsignals11();
  }, []);

  return (
    <Content Page_title="Strategy Description" button_status={false}>
      <div className="row mb-5">
        {StrategyData.data &&
          StrategyData.data.map((item) => {
            return (
              <>
                <div
                  className="col-12 col-sm-6 col-md-4"
                  style={{ height: "250px" }}
                >
                  <div className="card card-purple-blue text-white mb-3 mb-md-0">
                    <div className="d-flex justify-content-between ">
                      <div>
                        <p className="new-un">
                          {item.result.strategy_category}
                        </p>
                      </div>
                      <div>
                        <p className="new-de">{item.result.strategy_segment}</p>
                      </div>
                    </div>
                    <h4 className="card-new-heading">
                      {item.result.strategy_name}
                    </h4>
                    <div className="card-number text-center">
                      <div className="h3">Recommended</div>
                      <small>
                        <strong>
                          Capital : {item.result.strategy_amount} PER LOT
                        </strong>
                      </small>
                    </div>
                    <div className="card-body d-flex justify-content-between  align-items-end p-2">
                      <div className="card-description text-right">
                        <small
                          className="new-sma mx-2"
                          onClick={(e) => {
                            setshowModal(true);
                            setModalData(item.result);
                          }}
                        >
                          Info
                        </small>
                      </div>
                      <div className="card-description text-right ml-3">
                        <small className="new-sma">Join</small>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            );
          })}
      </div>

      {showModal ? (
        <>
          <Modal
            isOpen={showModal}
            size="lg"
            title="Strategy Information"
            hideBtn={true}
            // onHide={handleClose}
            handleClose={() => setshowModal(false)}
          >
            <div className="content ml-5 mr-5 ">
              <h5 className=" text-center">{ModalData.strategy_name}</h5>

              <li>{ModalData.strategy_description}</li>
              <div className="text-center">
                <h5 className=" mb-0">SETTINGS OF INDICATOR</h5>
                <span>
                  <img
                    src={ModalData.strategy_indicator}
                    alt="INDICATOR"
                    className="w-100 my-3 border border-dark"
                  />
                </span>
              </div>
              <div className="text-center">
                <h5 className=" ">NIFTY STRATEGY TESTER</h5>
                <span>
                  <img
                    src={ModalData.strategy_tester}
                    className="w-100 my-3 border border-dark"
                    alt="STRATEGY TESTER"
                  />
                </span>
              </div>
              <br />
              <div>
                <span style={{ fontSize: "13.5pt", whiteSpace: "pre-wrap" }}>
                  This strategy works best in trending type of market
                  conditions.
                </span>
                <div>
                  <span>Support :</span>
                  {/* <span> Email : info@trustalgo.net</span>
                  <span> Mobile : +918424978748</span> */}
                </div>
                <span style={{ fontSize: "13.5pt", color: "red" }}>
                  <b>Note</b>
                </span>
                <ul className="fw-bold">
                  <li>
                    Do not subscribe to the strategy without watching the
                    performance sheets and charts. Since this strategy works on
                    trend there will be multiple entries in 1 trading session.
                  </li>
                  <li>
                    We recommend 1 or 2 trades per day in order to gain capital
                    with calculative risk.
                  </li>
                  <li>
                    Increase lots size and re-entries according to your risk
                    appetite , we are not responsible for your in-calculative
                    losses.
                  </li>
                </ul>
              </div>
            </div>
          </Modal>
        </>
      ) : (
        ""
      )}
    </Content>
  );
};

export default StrategyDesc;
